<template>
  <div>
    <dx-data-grid ref='refBomExportGrid'
      :data-source='productSalesPriceInfoDetail'
      :height='gridHeightTree'
      :show-borders = 'true' :showRowLines = 'true' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :row-alternation-enabled="true"
      :focused-row-enabled="true"
      :auto-navigate-to-focused-row="false"
      key-expr="seqId"
      @cell-prepared="onCellPrepared"
    >
      <DxExport
        :enabled="true"
        :file-name="excelFileName"
      />
      <DxColumn
        v-if="$store.getters.getGroupName !== null"
        :caption="$store.getters.getGroupName"
        data-field="차종"
        width="80"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        :encodeHtml="false"
        data-field="품번depth"
        caption="품번"
        width="120"
      />
      <DxColumn
        :allowEditing='false'
        data-field="품명"
        caption="품명"
        width="180"
      />
      <DxColumn
        :allowEditing='true'
        caption="원단위"
        data-field="수량"
        :visible='true'
        format='#,##0.0000'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='true'
        caption="소요량"
        data-field="소요량"
        :visible='true'
        format='#,##0.0000'
        dataType="number"
      >
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        caption="품목유형"
        data-field="품목유형"
        :visible='true'
      >
        <DxLookup
          :data-source="itemTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        caption="자재유형"
        data-field="자재유형"
      >
        <DxLookup
          :data-source="meterialTypeLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        :allowEditing='false'
        data-field="재질"
        caption="재질"
      />
      <DxColumn
        :allowEditing='false'
        caption="단위"
        data-field="단위"
        :visible='true'
      >
        <DxLookup
          :data-source="unitLookup"
          display-expr="코드명"
          value-expr="코드"
        />
      </DxColumn>
      <DxColumn
        caption="판매가 기준정보"
        alignment='center'
      >
        <DxColumn
          caption="판매가적용일"
          :allowEditing='false'
          data-field="기준판매가적용일자"
          dataType= 'date'
          format='yyyy-MM-dd'
          alignment='center'>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="판매가"
          data-field="기준판매가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="스크랩가"
          data-field="기준스크랩가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="코일가"
          data-field="기준코일가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="재료비(NET)"
          data-field="기준재료비net"
          :visible='true'
          dataType="number"
          format='#,##0.00'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="재료관리비"
          data-field="기준재료관리비"
          :visible='true'
          dataType="number"
          format='#,##0.00'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="HW가격"
          data-field="기준hw가격"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="소계(변동재료비)"
          data-field="기준변동재료비"
          :calculate-cell-value="calcBaseMaterialCostPrice"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="판매가공비(A)"
          data-field="판매가공비"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
      </DxColumn>
      <DxColumn
        :caption="getSelectedDate()"
        alignment='center'
      >
        <DxColumn
          caption="판매가적용일"
          :allowEditing='false'
          data-field="판매가적용일자"
          dataType= 'date'
          format='yyyy-MM-dd'
          alignment='center'>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="판매가"
          data-field="판매가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="스크랩가"
          data-field="스크랩가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="코일가"
          data-field="코일가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="재료비(NET)"
          data-field="재료비net"
          :visible='true'
          dataType="number"
          format='#,##0.00'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="재료관리비"
          data-field="재료관리비"
          :visible='true'
          dataType="number"
          format='#,##0.00'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="HW가격"
          data-field="hw가격"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="소계(변동재료비)(B)"
          data-field="변동재료비"
          :calculate-cell-value="calcMaterialCostPrice"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="산출판매가(A+B)"
          data-field="산출판매가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
      </DxColumn>
      <DxSummary :calculate-custom-summary="calculateSummary">
        <DxTotalItem
          value-format='#,##0'
          column="기준코일가"
          display-format="{0} (건)"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="avg"
          column="기준판매가"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.00'
          summary-type="sum"
          column="기준재료비net"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.00'
          summary-type="sum"
          column="기준재료관리비"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.0'
          summary-type="sum"
          column="기준hw가격"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.00'
          summary-type="sum"
          column="기준변동재료비"
          display-format="{0}"
        />
        <DxTotalItem
          name="SalesConstantPrice"
          value-format='#,##0.000'
          summary-type="custom"
          display-format="{0}"
          show-in-column="판매가공비"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="avg"
          column="판매가"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.00'
          summary-type="sum"
          column="재료비net"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.00'
          summary-type="sum"
          column="재료관리비"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.0'
          summary-type="sum"
          column="hw가격"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0.000'
          summary-type="sum"
          column="변동재료비"
          display-format="{0}"
        />
        <DxTotalItem
          name="CalcSalesPrice"
          value-format='#,##0'
          summary-type="custom"
          display-format="{0}"
          show-in-column="산출판매가"
        />
      </DxSummary>
    </dx-data-grid>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxExport, DxSummary, DxTotalItem, DxColumn, DxLookup } from 'devextreme-vue/data-grid'
export default {
  name: 'ProductSalesPriceDetailTemp',
  data: function () {
    return {
      gridHeightTree: null,
      productSalesPriceInfoDetail: null,
      itemTypeLookup: null,
      meterialTypeLookup: null,
      processingTypeLookup: null,
      unitLookup: null,
      excelFileName: null,
      mrpExcelExportInfo: []
    }
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    baseDate: {
      type: String,
      default: null
    }
  },
  components: {
    DxColumn,
    DxLookup,
    DxDataGrid,
    DxExport,
    DxSummary,
    DxTotalItem
  },
  created () {
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
  },
  mounted () {
    this.refreshCostDetail(this.item.key)
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcCostSum (row) {
      return (row.재료비소계 + row.도급비용)
    },
    calcBaseMaterialCostPrice (row) {
      return (row.기준재료비net + row.기준재료관리비 + row.기준hw가격)
    },
    calcMaterialCostPrice (row) {
      return (row.재료비net + row.재료관리비 + row.hw가격)
    },
    calculateSummary (options) {
      if (options.name === 'SalesConstantPrice') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0
        } else if (options.summaryProcess === 'finalize') {
          if (this.productSalesPriceInfoDetail === null) return
          let sum = 0
          this.productSalesPriceInfoDetail.forEach(item => {
            console.log(item.기준재료비net, item.기준재료관리비, item.기준변동재료비)
            sum += item.기준재료비net + item.기준재료관리비 + item.기준hw가격
          })
          console.log(sum)
          options.totalValue = this.productSalesPriceInfoDetail[0].기준판매가 - sum
        }
      } else if (options.name === 'CalcSalesPrice') {
        if (options.summaryProcess === 'start') {
          options.totalValue = 0
        } else if (options.summaryProcess === 'finalize') {
          if (this.productSalesPriceInfoDetail === null) return
          let baseSum = 0
          let currentSum = 0
          this.productSalesPriceInfoDetail.forEach(item => {
            console.log(item.기준재료비net, item.기준재료관리비, item.기준변동재료비)
            baseSum += item.기준재료비net + item.기준재료관리비 + item.기준hw가격
            currentSum += item.재료비net + item.재료관리비 + item.hw가격
          })
          options.totalValue = (this.productSalesPriceInfoDetail[0].기준판매가 - baseSum) + currentSum
        }
      }
    },
    getSelectedDate () {
      return `${this.baseDate} 판매가 정보`
    },
    onCellPrepared (e) {
      if (e.column.dataField === undefined) return

      if (e.rowType === 'header' &&
          (e.column.dataField.indexOf('재료관리비') >= 0 ||
          e.column.dataField.indexOf('재료비net') >= 0 ||
          e.column.dataField.indexOf('hw가격') >= 0 ||
          e.column.dataField.indexOf('변동재료비') >= 0)
      ) {
        this.$Q(e.cellElement).css('color', 'red')
      }
    },
    refreshCostDetail (goodsNo) {
      this.excelFileName = `${goodsNo}_판매가산출내역`
      this.$emit('refresh-detail-completed')
      this.$_sp.runNoEncodeFindProc('spFindAllSalesPriceByGoodsNoAndCoilPrice', { 완제품코드: goodsNo, 기준일: this.baseDate })
        .then((data) => {
          // this.$emit('refresh-detail-completed')
          this.productSalesPriceInfoDetail = this.$_sp.MakeModel(data)
          console.log(this.productSalesPriceInfoDetail)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.dx-master-detail-cell {
  padding-top: 8px!important;
}
</style>
